
import jwtDecode from "jwt-decode";

interface JwtType {
  sid?: string
  ud?: number
  un?: string
}

export function decodeJwt(token): JwtType {
  let data = {}
  try {
     data = jwtDecode(token)
  } catch (error) {
    console.error(error)
  }
  return data
}
